import { React } from '_core';

const MetricBasketReturns = () => <></>;
export default MetricBasketReturns;
